export default __webpack_public_path__ + "static/media/udacity-logo.acdd4ccc.svg";